import React from "react";
var __jsx = React.createElement;
var OilGuidanceSteps = function OilGuidanceSteps(_ref) {
  var _section$content;
  var section = _ref.section;
  if (!((_section$content = section.content) !== null && _section$content !== void 0 && _section$content.length)) return null;
  return /*#__PURE__*/React.createElement("section", {
    className: "py-7 ps-4 md:pt-16 md:pb-8 md:px-6"
  }, section.title && /*#__PURE__*/React.createElement("h2", {
    className: "text-xl md:text-[30px] font-bold text-[#1B2035] md:text-center mb-5 md:mb-8 pe-4 md:pe-0"
  }, section.title), /*#__PURE__*/React.createElement("ul", {
    className: "flex gap-3 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none [scrollbar-width:none] [&::-webkit-scrollbar]:hidden list-none pt-5 pb-3 pe-4 md:pb-0 md:pt-6 md:max-w-[1200px] md:mx-auto m-0"
  }, section.content.map(function (step) {
    return /*#__PURE__*/React.createElement("li", {
      key: step.id,
      className: "snap-start flex-none w-[160px] md:flex-1 md:w-auto min-w-0 relative"
    }, /*#__PURE__*/React.createElement("span", {
      className: "absolute top-0 start-0 -translate-y-1/2 w-8 h-8 md:w-9 md:h-9 bg-white rounded-full flex items-center justify-center text-base md:text-lg font-extrabold text-[#1B2035] shadow-sm z-10"
    }, step.label), /*#__PURE__*/React.createElement("div", {
      className: "md:h-[130px] rounded-[14px] md:rounded-lg shadow-sm px-3 py-5 md:px-6 md:pt-4 md:pb-4 h-[170px] flex flex-col gap-2.5 md:gap-2 bg-cover bg-center bg-no-repeat",
      style: step.image ? {
        backgroundImage: "url(".concat(step.image, ")")
      } : {
        backgroundColor: step.color || "#FFF3E0"
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-[15px] md:text-base font-extrabold text-[#1B2035] m-0 leading-[1.35] text-start"
    }, step.title), step.sub_title && /*#__PURE__*/React.createElement("p", {
      className: "text-xs md:text-[13px] font-normal text-[#5A6880] m-0 leading-relaxed text-start"
    }, step.sub_title)));
  })));
};
export default OilGuidanceSteps;